import React, { useContext } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box, Button } from '@mui/material';
import useHospitalCoverateContext from '../context/useHospitalCoverateContext';

function Table() {
  const { loading, coverageData, totalUnassigned, handleExport } = useContext(
    useHospitalCoverateContext,
  );

  const handlePercentCellClassName = (manager, value) => {
    let className;
    if (parseFloat(value) >= 101 && manager !== 'Total') {
      className = 'cell-super-green';
    }
    if (parseFloat(value) >= 90 && parseFloat(value) <= 100 && manager !== 'Total') {
      className = 'cell-green';
    }
    if (parseFloat(value) >= 85 && parseFloat(value) <= 89 && manager !== 'Total') {
      className = 'cell-yellow';
    }
    if (parseFloat(value) < 85 && manager !== 'Total') {
      className = 'cell-red';
    }
    return className;
  };

  const columns = [
    {
      field: 'manager',
      sortable: false,
      headerName: 'HTAM Name',
      flex: 1,
      width: 200,
      headerClassName: 'call-reach-theme-style',
      renderCell: ({ row }) => `${row.manager === 'Total' ? '' : row.manager}`,
    },
    {
      field: 'rep_name',
      sortable: false,
      headerName: 'HTAR Name',
      flex: 1,
      headerClassName: 'call-reach-theme-style',
      width: 200,
    },
    {
      field: 'call_reach_protect_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-cell-child-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_protect_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-cell-child-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_protect_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-p-child-reach-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_reach_protect_percent),
      renderCell: ({ row }) => `${row.call_reach_protect_percent.toFixed(2)}`,
    },
    //
    {
      field: 'call_reach_develop_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-cell-child-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_develop_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-cell-child-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_develop_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-d-child-reach-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_reach_develop_percent),
      renderCell: ({ row }) => `${row.call_reach_develop_percent.toFixed(2)}`,
    },
    //
    {
      field: 'call_reach_gain_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-cell-child-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_gain_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-cell-child-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_gain_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-g-child-reach-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_reach_gain_percent),
      renderCell: ({ row }) => `${row.call_reach_gain_percent.toFixed(2)}`,
    },
    //
    {
      field: 'call_reach_total_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-cell-child-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_total_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-cell-child-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_reach_total_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_reach_total_percent),
      renderCell: ({ row }) => `${row.call_reach_total_percent.toFixed(2)}`,
    },
    {
      field: 'call_volume_total_t',
      sortable: false,
      headerName: 'T',
      headerClassName: 'call-cell-child-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_volume_total_a',
      sortable: false,
      headerName: 'A',
      headerClassName: 'call-cell-child-reach-theme-style',
      headerAlign: 'center',
    },
    {
      field: 'call_volume_total_percent',
      sortable: false,
      headerName: '%',
      headerClassName: 'call-reach-theme-style',
      headerAlign: 'center',
      cellClassName: ({ row }) =>
        handlePercentCellClassName(row.manager, row.call_volume_total_percent),
      renderCell: ({ row }) => `${row.call_volume_total_percent.toFixed(2)}`,
    },
  ];

  const columnGroupingModel = [
    {
      groupId: 'call_reach',
      headerName: `Total Unassigned: ${totalUnassigned}`,
      headerAlign: 'right',
      align: 'right',
      headerClassName: 'call-header-reach-theme-style',
      children: [
        {
          groupId: 'call_reach_protect',
          headerName: 'P-Reach',
          headerAlign: 'center',
          headerClassName: 'call-p-reach-theme-style',
          children: [
            { field: 'call_reach_protect_t' },
            { field: 'call_reach_protect_a' },
            {
              field: 'call_reach_protect_percent',
              headerClassName: 'call-p-child-reach-theme-style',
            },
          ],
        },
        {
          groupId: 'call_reach_develop',
          headerName: 'D-Reach',
          headerAlign: 'center',
          headerClassName: 'call-d-reach-theme-style',
          children: [
            { field: 'call_reach_develop_t' },
            { field: 'call_reach_develop_a' },
            { field: 'call_reach_develop_percent' },
          ],
        },
        {
          groupId: 'call_reach_gain',
          headerName: 'G-Reach',
          headerAlign: 'center',
          headerClassName: 'call-g-reach-theme-style',
          children: [
            { field: 'call_reach_gain_t' },
            { field: 'call_reach_gain_a' },
            { field: 'call_reach_gain_percent' },
          ],
        },
        {
          groupId: 'total_call_reach',
          headerName: 'Total Call Reach (ALL CLASSES)',
          headerAlign: 'center',
          headerClassName: 'call-reach-theme-style',
          children: [
            { field: 'call_reach_total_t' },
            { field: 'call_reach_total_a' },
            { field: 'call_reach_total_percent' },
          ],
        },
        {
          groupId: 'total_call_volumn',
          headerName: 'Total Call Volume (ALL CLASSES)',
          headerAlign: 'center',
          headerClassName: 'call-reach-theme-style',
          children: [
            { field: 'call_volume_total_t' },
            { field: 'call_volume_total_a' },
            { field: 'call_volume_total_percent' },
          ],
        },
      ],
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant='contained'
            color='success'
            onClick={handleExport}
            sx={{
              marginLeft: '20px',
              marginBottom: '20px',
              paddingTop: '10px',
            }}
          >
            Export Hospital Coverage
          </Button>
        </Box>
        <Box
          className='table-container'
          sx={{
            height: '1000px',
            marginLeft: '20px',

            '& .MuiDataGrid-row': {
              backgroundColor: '#e6e6e6',
              pointerEvents: 'none',
            },
            '& .call-cell-child-reach-theme-style': {
              backgroundColor: '#e6e6e6',
              color: '#000',
              fontWeight: 'bold',
            },
            '& .call-p-reach-theme-style': {
              backgroundColor: '#c6ff03',
              border: '1px solid #b5e900',
              color: '#000',
              fontWeight: 'bold',
            },
            '& .call-p-child-reach-theme-style': {
              backgroundColor: '#c6ff03',
              border: '1px solid #b5e900',
              color: '#000',
              fontWeight: 'bold',
            },
            '& .call-d-reach-theme-style': {
              backgroundColor: '#ffba03',
              border: '1px solid #e9a900',
              color: '#000',
              fontWeight: 'bold',
            },
            '& .call-d-child-reach-theme-style': {
              backgroundColor: '#ffba03',
              border: '1px solid #e9a900',
              color: '#000',
              fontWeight: 'bold',
            },
            '& .call-g-reach-theme-style': {
              backgroundColor: '#5080ff',
              border: '1px solid #366eff',
              color: '#000',
              fontWeight: 'bold',
            },
            '& .call-g-child-reach-theme-style': {
              backgroundColor: '#5080ff',
              border: '1px solid #366eff',
              color: '#000',
              fontWeight: 'bold',
            },
            '& .call-header-reach-theme-style .MuiDataGrid-columnHeaderTitle': {
              color: '#DC143C',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
              color: '#000',
            },
            '& .call-reach-theme-style': {
              backgroundColor: '#a6a6a6',
              border: '1px solid #a6a6a6',
            },
            '& .total-row': {
              backgroundColor: '#a6a6a6',
              color: '#000',
              fontWeight: '600',
            },
            '& .call-volume-theme-style': {
              backgroundColor: '#A9A9A9',
              border: '1px solid #DCDCDC',
            },
            '& .call-volume-theme-style div .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
              color: '#000',
            },
            '& .call-concentration-theme-style': {
              backgroundColor: '#696969',
              border: '1px solid #A9A9A9',
            },
            '& .call-concentration-theme-style div .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
              color: '#fff',
            },
            '& .cell-green': {
              backgroundColor: '#ACE1AF',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-yellow': {
              backgroundColor: '#f0ad4e',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-red': {
              backgroundColor: '#FFADB0',
              color: '#000',
              fontWeight: '600',
            },
            '& .cell-super-green': {
              backgroundColor: '#5cb85c',
              color: '#000',
              fontWeight: '600',
            },
          }}
        >
          <DataGridPro
            loading={loading}
            rows={coverageData}
            columns={columns}
            columnGroupingModel={columnGroupingModel}
            experimentalFeatures={{ columnGrouping: true }}
            getRowClassName={(params) => (params.row.manager === 'Total' ? 'total-row' : '')}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
export default Table;
